var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "1 -1 100 100",
    style: {
      enableBackground: "new 1 -1 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.7,2.5l-4.1,3.6l9.6,11c-5.8,0.3-10.3,5.5-9.6,11.4c0.5,4.5,4.2,8.3,8.7,9c2.5,0.3,4.9-0.2,6.8-1.5v38.8   c0,2.5-1.8,4.9-4.4,5.1c-2.9,0.3-5.3-1.9-5.3-4.9V57.7c0-5.1-4.1-9.2-9.2-9.2h-2.4V17c0-7.1-5.8-13-13-13H25.2c-7.1,0-13,5.8-13,13   v70.5c0,4.4,3.6,8,8,8H55c4.4,0,8-3.6,8-8V53.9h2.4c2.1,0,3.8,1.7,3.8,3.8v16.9c0,5.5,4.1,10.3,9.5,10.6c5.9,0.4,11-4.3,11-10.3   V26.6c0-3.1-1.2-6.2-3.2-8.4L72.7,2.5z M79,32.2c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9S81.5,32.2,79,32.2z    M54.8,35.6H21.2V19.4c0-2.4,1.9-4.3,4.3-4.3h24.8c2.4,0,4.3,1.9,4.3,4.3v16.2H54.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.c600ff4b.svg";
export { ForwardRef as ReactComponent };